import React, { useState } from "react";
import { useSelector } from "react-redux";
import { scheduleBoardMessagesQuery } from "../../../shared/utils/entitiesFiltersUtils";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import Popup from "../../../shared/components/ui/popup/Popup";
import HeaderPopup from "../../../shared/components/ui/popup/headerPopup/HeaderPopup";
import ContentsPopup from "../../../shared/components/ui/popup/contentPopup/ContentPopup";
import ScheduleEditBody from "../../../shared/components/features/scheduleSystem/scheduleEditBody/ScheduleEditBody";
import ScheduleViewBody from "../../../shared/components/features/scheduleSystem/scheduleViewBody/ScheduleViewBody";
import actionType from "../../../shared/enums/actionType";
import classes from "./SchedulePopup.module.css";

const SchedulePopup = ({ onClose, mainClasses = []}) => {

    const { texts } = useSelector((state) => state.translate);
    const scheduleEntities = useSelector((state) => selectEntitiesByFilters(state, scheduleBoardMessagesQuery));
    const [mode, setMode] = useState(scheduleEntities?.length > 0  ? actionType.view : actionType.edit);

    return (
        <Popup close={onClose} title={texts.schedulePopupTitle} dropClass={classes.BackdropPopupClass} dropClassClose={classes.DropClassClose}>
            <HeaderPopup className={classes.HeaderPopup}>
                <p className={classes.Title}>{texts.schedulePopupTitle}</p>
            </HeaderPopup>
            <ContentsPopup className={classes.ContentsPopup} scrollDropClass={classes.SchedulePopupScroll} scrollContentClass={classes.SchedulePopupScrollContent}>
                {mode === actionType.edit ?
                 <ScheduleEditBody texts={texts} mainClasses={mainClasses} scheduleEntities={scheduleEntities} onClose={onClose} /> 
                 :
                  <ScheduleViewBody scheduleEntities={scheduleEntities} setMode={setMode} canEdit={true} />
                }
            </ContentsPopup>
        </Popup>
    );
};
export default SchedulePopup;